import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import {Table} from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import { bin } from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import ModalNew from './ModalNew';

var Config = require('../../config');

class DiaryList extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeDate = this.handleChangeDate.bind(this);
		this.handleChangeFilter = this.handleChangeFilter.bind(this);
		this.eventAgenda = this.eventAgenda.bind(this);
		this.onRegister = this.onRegister.bind(this);
		this.newEvent = this.newEvent.bind(this);
		this.getList = this.getList.bind(this);
		this.deletePre = this.deletePre.bind(this);
		this.getHoursByDate = this.getHoursByDate.bind(this);

		this.state = {
			events:[],
			show_all:false,
			start_date:"",
			hf_id:sessionStorage.getItem('health_facilities_id'),
			columns:[],
			hours:[]
		}
	}

	componentDidMount() {
  		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0]
			});
			this.getHoursByDate();
		})

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=PRE_OFFERS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	});
	}	

	async getHoursByDate(){
		await fetch(Config.default.apiGateway.URL+'pre_offer_days/get_hours_by_date?date='+this.state.start_date,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){
          		this.setState({ hours: response });
				this.getList("all","00:00","23:59");
        	}else{
				this.setState({ hours: [], events:[] });
			}
      	});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getList(option, startHour, endHour){
		var url = "";

		if(option === "all"){
			url = "pre_offers/all?date="+this.state.start_date+"&hf_id="+this.state.hf_id;
		}else{
			url = 'pre_offers?start_date='+this.state.start_date+' '+startHour+
			'&end_date='+this.state.start_date+' '+endHour+'&hf_id='+this.state.hf_id;
		}

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+url,{
			method:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}

		}).then(response => {
			if(response !== undefined){
				console.log(response);
				var events = [];
				response.map((res, i)=>{
					var date = moment(res.timestamp_date).format('YYYY-MM-DD');

					events.push({
						id:res.id,
						title:res.donor,
						donation_type:res.donation_type,
						extraction_type:res.extraction_type,
						//start:new Date(date+' '+res.timestamp_hour),
						start:moment(date).format('DD/MM/YYYY'),
						hour:moment(res.timestamp_hour, 'H:mm:ss').format('HH:mm'),
						//end:new Date(date+' '+res.timestamp_hour),
						status:res.status,
						color:res.status === "" ? '#3174ad' : '#31ad6e',
						folio: res.folio
					});
				})
				this.setState({events:events});
			}
		});
	}

	onRegister(e){
		var id = e.target !== undefined ? e.target.id : e;
		this.props.history.push('/offers/register/'+id);
	}

	eventAgenda(props){
        return <div style={{display:'flex'}}>
	        <div style={{width:'77%'}}>
	        	<em>
	        		{props.event.title+' - '+props.event.extraction_type+' - '+props.event.donation_type}
	        	</em>
	        </div>
	        <div style={{width:'15%'}}>
	        	<em>
	        		{props.event.status}
	        	</em>
	        </div>
	        <div style={{width:'8%'}}>
	        	{props.event.status === "" ?
	        		<button className="btn btn-info" id={props.event.id} onClick={(e)=> this.onRegister(e)}>Registro</button>

	        	:null}
	        </div>
        </div>
    }

    newEvent(e, hour){
		e.preventDefault();
		this.modal_new.handleShow(this.state.start_date, hour, null);
    }

    handleChange(e){
    	this.setState({
    		[e.target.name]: e.target.value
    	});
		console.log([e.target.name]);
    }

	async handleChangeDate(e){
		await this.setState({
    		[e.target.name]: e.target.value,
			hour: "all"
    	});
		await this.getHoursByDate();
	}

	handleChangeFilter(e){
    	this.setState({
    		[e.target.name]: e.target.value
    	});

		if(e.target.value === "all"){
			this.getList("all", "00:00","23:59");
		}else{
			var hourItem = this.state.hours[e.target.value];
			this.getList("hour",hourItem.start,hourItem.end);
		}
    }

    editPre(id){
    	//this.props.history.push('/event/edit/'+id);
		this.modal_new.handleShow(null,null,id);
    }

    deletePre(id){
    	swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
    	}, (isConfirm)=> {
        	if (isConfirm) {
          		fetch(Config.default.apiGateway.URL+'pre_offers/'+id ,{ 
		            method: 'delete',
		            headers: new Headers({
               			'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
               			'Accept': 'application/json',
              			'Content-Type': 'application/json',
            		})
          		})
          		.then(res => {
            		if(res.ok){
              			return res.json();
        			}else{
              			res.text().then(function(result) {
                			swal('¡Error!', result, 'error');
              			});
            	}})
          		.then(res => {
              		if(res !== undefined){
                		swal('Buen Trabajo', 'Registro Eliminado','success');
                		this.getList("all", "00:00", "23:59");
              		}
          		})
        	}
    	});
    }

	showColumn(column_name){
		for(var i =0; i < this.state.columns.length;i++){
			if(this.state.columns[i]=== column_name){
				return false;
		  }
		}

	  return true;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Agenda
					</h5>
				</div>

				<Help 
					{...this.props}
					menu={"help_donors"} 
					submenu={"help_pre_offers"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha</span>
						<input type="date" name="start_date" id="start_date" value={this.state.start_date} 
							className="form-control hour-input" onChange={this.handleChangeDate}/>
					</div>
				</div>

				{this.state.hours.map((h, i)=>{
					return <div className="col-xs-1">
						<button className="btn" style={{margin:"5px", backgroundColor:h.color}} 
						onClick={e =>this.newEvent(e,h.start)} disabled={h.full || h.locked}>
							<span>{h.start +" - "+h.end}</span>
						</button>
					</div>
				})}
				
				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-2" style={{padding:"5px"}}>
						<select className="form-control" name="hour" id="hour" value={this.state.hour} 
							onChange={this.handleChangeFilter}>
							<option value="all">Todos</option>
							{this.state.hours.map((h, i)=>{
								return <option key={i} value={i}>
									{h.start +" - "+h.end}
								</option>
							})}
						</select>
					</div>
				</div>
				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th hidden={this.showColumn('FOLIO')}>Folio</th>
								<th hidden={this.showColumn('DATE')}>Fecha</th>
								<th hidden={this.showColumn('HOUR')}>Hora</th>
								<th hidden={this.showColumn('EVENT')}>Evento</th>
								<th hidden={this.showColumn('STATUS')}>Estatus</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.events.map((ev, i)=>(
								<tr key={i}>
									<td hidden={this.showColumn('FOLIO')}>{ev.folio}</td>
									<td hidden={this.showColumn('DATE')}>{ev.start}</td>
									<td hidden={this.showColumn('HOUR')}>{ev.hour}</td>
									<td hidden={this.showColumn('EVENT')}>{ev.title+' - '+ev.extraction_type+' - '+ev.donation_type}</td>
									<td hidden={this.showColumn('STATUS')}>{ev.status}</td>
									<td>
										{ev.status === "" ?
							        		<button className="btn btn-info" id={ev.id} 
							        			style={{marginRight:'8px'}}
							        			onClick={(e)=> this.onRegister(e)}>
							        			Registro
							        		</button>
							        	:null}
							        	{ev.status === "" ?
							        		<button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
												onClick={this.editPre.bind(this,ev.id)}>
												<SvgIcon icon={pencil2} size={24} />
											</button>
							        	: null}

							        	{ev.status === "" ?
							        		<button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
												onClick={this.deletePre.bind(this,ev.id)}>
												<SvgIcon icon={bin} size={24} />
											</button>
							        	: null}
							        	
									</td>
								</tr>

							))}
						</tbody>
					</Table>

				</div>

				<ModalNew {...this.props} onRef={ref => (this.modal_new = ref)} getList={this.getList}/>
			</div>
		)
	}
}

export default translate('translations')(DiaryList);